module.exports = __webpack_public_path__ + "static/img/7.66647042.png";